export enum UpdateInfoUserType {
	Personal = "personal_data_change__name__citizenship__date_of_birth_",
	Address = "home_address_change",
	Phone = "phone_number_change",
	Email = "email_address_change"
}

export enum ChangeEmailStep {
	UpdateData,
	VerificationCode,
	EmailConfirmation
}

export enum ChangeAddressStep {
	AutoAddress,
	ManualAddress,
	VerificationCode
}
